export default __webpack_public_path__ + "static/media/0_5Q_7VXyQ8xo4Dgpp.1fdee343.webp";